<template>
  <details v-if="summary" class="vote-participation-rules" open>
    <summary>{{ title }}</summary>
    <dl>
      <div v-for="(row, index) in summary.items" :key="index"><dt>{{ row.title }}</dt><dd>{{ row.detail }}</dd></div>
    </dl>
    <p v-if="summary.description">{{ summary.description }}</p>
  </details>
</template>
<script setup>
import { computed } from 'vue';
const props = defineProps({ activity: { type: Object, default: null }, title: { type: String, default: '参与规则' } });
// 只读取公开的会员规则分区，不从后台JSON或个人票额猜测条件。
const summary = computed(() => props.activity?.ruleSections?.find(section => section?.title === '投票规则' && Array.isArray(section.items) && section.items.length));
</script>
<style scoped>
.vote-participation-rules { min-width:0;margin:20px 0;color:var(--act-text,#303442);font-size:13px;line-height:1.75; }
summary { display:flex;align-items:center;justify-content:space-between;min-height:44px;cursor:pointer;font-size:15px;font-weight:600;list-style:none; }
summary::-webkit-details-marker { display:none; }
summary::after { content:'⌄';color:var(--act-secondary,#616783);transition:transform .15s; }
details[open] summary::after { transform:rotate(180deg); }
summary:focus-visible { outline:2px solid var(--vote-ink,#0878cc);outline-offset:3px; }
dl { margin:0; }
dl > div { display:grid;grid-template-columns:7em minmax(0,1fr);gap:12px;padding:10px 0;border-bottom:1px solid var(--act-line,#e8edf3); }
dt { color:var(--act-secondary,#616783);font-weight:400; }
dd { min-width:0;margin:0;overflow-wrap:anywhere; }
p { margin:12px 0 0;color:var(--act-secondary,#616783);font-size:12px;line-height:1.8; }
</style>
